import { render, staticRenderFns } from "./subMaintenanceDetail.vue?vue&type=template&id=38e34206&scoped=true"
import script from "./subMaintenanceDetail.vue?vue&type=script&lang=js"
export * from "./subMaintenanceDetail.vue?vue&type=script&lang=js"
import style0 from "./subMaintenanceDetail.vue?vue&type=style&index=0&id=38e34206&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e34206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e34206')) {
      api.createRecord('38e34206', component.options)
    } else {
      api.reload('38e34206', component.options)
    }
    module.hot.accept("./subMaintenanceDetail.vue?vue&type=template&id=38e34206&scoped=true", function () {
      api.rerender('38e34206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManage/maintenance/subMaintenanceDetail.vue"
export default component.exports